import { push } from "connected-react-router";
import constants from "../constants";
const axios = require("axios");

export const setUserLogin = (userToken, userRole) => {
  return {
    type: constants.reducerActions.login,
    userToken,
    userRole,
  };
};

export const loginUser = (loginDetails) => {
  return async (dispatch) => {
    try {
      const url = `/login`;
      const { responseStatus, responseBody } = await axios.post(
        url,
        loginDetails
      );
      if (responseStatus === constants.status.success && responseBody.success) {
        const { data } = responseBody;
        dispatch(setUserLogin(data.access_token, data.role));
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("role", data.role);
        if (data.role === constants.roles.client) {
          dispatch(push("/client/home"));
        } else if (data.role === constants.roles.consultant) {
          dispatch(push("/consultant/home"));
        } else if (data.role === constants.roles.admin) {
          dispatch(push("/admin/home"));
        }
      }
    } catch (error) {
      return error.response.status;
    }
  };
};

const setEmailSent = (isSent) => {
  return {
    type: constants.reducerActions.mailSent,
    isSent,
  };
};

export const forgotPassword = (email) => {
  return async (dispatch) => {
    const url = `/forgot-password?email=${email}`;
    try {
      const { responseStatus } = await axios.post(url);
      if (responseStatus === constants.status.success) {
        dispatch(setEmailSent(true));
      }
    } catch (error) {
      return error.response.status;
    }
  };
};

export const verifyEmail = (token) => async (dispatch) => {
  const url = `/verify-email?email_token=${token}`;
  try {
    const { responseStatus, responseBody } = await axios.post(url);
    localStorage.setItem("token", token);
    localStorage.setItem("role", responseBody.data.accountType);
    return { responseStatus, accountType: responseBody.data.accountType };
  } catch (error) {
    return { responseStatus: error.response.status };
  }
};

const setPasswordUpdated = (isPasswordUpdated) => {
  return {
    type: constants.reducerActions.changePassword,
    isPasswordUpdated,
  };
};

export const resetPassword = (resetDetails) => async (dispatch) => {
  try {
    const url = "/reset-password";
    const response = await axios.put(url, resetDetails);
    if (response.status === constants.status.success) {
      dispatch(setPasswordUpdated(true));
    }
  } catch (error) {
    console.log(error);
  }
};

export const setUserDetails = (userDetails) => {
  return {
    type: constants.reducerActions.userDetails,
    userDetails,
  };
};

export const getUserDetails = () => async (dispatch) => {
  try {
    const url = `/me`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setUserDetails(data));
      return {
        responseStatus,
      };
    }
  } catch (error) {
    return {
      responseStatus: error.response.status,
    };
  }
};

export const changePassword = (data) => async (dispatch) => {
  try {
    const url = "/change-password";
    const { responseStatus } = await axios.put(url, data);
    return { responseStatus };
  } catch (error) {
    console.log(error);
    return { responseStatus: error.response.status };
  }
};

export const signOut = () => async (dispatch) => {
  try {
    localStorage.clear();
    dispatch(push("/login"));
  } catch (error) {
    console.log(error);
  }
};

export const googleAuthentication = (token, role) => async (dispatch) => {
  try {
    const url = "/google-signup-signin";
    const data = {
      idToken: token,
      role: role || "",
    };
    const { responseStatus, responseBody } = await axios.post(url, data);
    if (responseStatus === constants.status.created) {
      localStorage.setItem("token", responseBody.data.access_token);
      localStorage.setItem("role", data.role);
      dispatch(setUserLogin(true, responseBody.data.access_token, data.role));
    }
    if (responseStatus === constants.status.success) {
      localStorage.setItem("token", responseBody.data.access_token);
      localStorage.setItem("role", responseBody.data.role);
      dispatch(
        setUserLogin(
          true,
          responseBody.data.access_token,
          responseBody.data.role
        )
      );
    }
    if (responseStatus === constants.status.unAuthorative) {
      return { responseStatus };
    }

    return { responseStatus, responseToken: responseBody.data.access_token };
  } catch (error) {
    console.log(error);
    localStorage.setItem("token", error.response.data.data.access_token);
    localStorage.setItem("role", error.response.data.data.role);
    dispatch(
      setUserLogin(
        true,
        error.response.data.access_token,
        error.response.data.role
      )
    );
    return {
      responseStatus: error.response.status,
      responseToken: error.response.data.data.access_token,
    };
  }
};

export const getLinkedInAcessToken =
  (redirectUri, accessCode, role) => async (dispatch) => {
    try {
      const url = "/linkedin-signin-signup";
      const data = {
        redirectUri,
        accessCode,
        role,
      };
      const { responseStatus, responseBody } = await axios.post(url, data);
      if (responseStatus === constants.status.created) {
        localStorage.setItem("token", responseBody.access_token);
        localStorage.setItem("role", data.role);
      }
      if (responseStatus === constants.status.success) {
        localStorage.setItem("token", responseBody.data.access_token);
        localStorage.setItem("role", responseBody.data.role);
        dispatch(
          setUserLogin(
            true,
            responseBody.data.access_token,
            responseBody.data.role
          )
        );
      }
      return {
        responseStatus,
      };
    } catch (error) {
      localStorage.setItem("token", error.response.data.data.access_token);
      localStorage.setItem("role", error.response.data.data.role);
      dispatch(
        setUserLogin(
          true,
          error.response.data.access_token,
          error.response.data.role
        )
      );
    }
  };

export const addNewComment =
  (
    offerId,
    comment,
    commentType,
    progressParentId,
    clarificationStatus,
    percentageCompletion,
    fileIds
  ) =>
  async (dispatch) => {
    try {
      const url = "/job/progress";
      const data = {
        offerId,
        comment,
        commentType,
        progressParentId,
        clarificationStatus,
        percentageCompletion,
        fileIds,
      };
      const { responseStatus } = await axios.post(url, data);
      await dispatch(getOfferComments(offerId));
      // set the upload files to []
      return {
        responseStatus,
      };
    } catch (error) {
      console.log(error);
      return {
        responseStatus: error.response.status,
      };
    }
  };

const setAllComments = (allComments) => {
  return {
    type: constants.consultantActions.allComments,
    allComments,
  };
};

export const getOfferComments = (offerId) => async (dispatch) => {
  try {
    const url = `/${offerId}/comments`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      dispatch(setAllComments(responseBody.data));
    }
  } catch (error) {
    console.log(error);
  }
};

const setJobDetail = (jobDetail) => {
  return {
    type: constants.reducerActions.progress,
    jobDetail,
  };
};

export const getOfferProgress = (jobId) => async (dispatch) => {
  try {
    let url = `/consultant/jobs/${jobId}`;
    const role = localStorage.getItem("role");
    if (role === constants.roles.client) {
      url = `/client/jobs/${jobId}`;
    }
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setJobDetail(data));
    }
  } catch (error) {
    console.log(error);
  }
};

const setAllNotifications = (allNotifications, totalNotifications) => {
  return {
    type: constants.reducerActions.notifications,
    allNotifications,
    totalNotifications,
  };
};

export const getAllNotifications = (page) => async (dispatch) => {
  try {
    const url = `/notifications?page=${page}&size=10`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setAllNotifications(data.items, data.total));
    }
  } catch (error) {
    console.log(error);
  }
};

export const readAllNotifications = () => async (dispatch) => {
  try {
    const url = "/notifications";
    const { responseStatus, responseBody } = await axios.put(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setAllNotifications(data));
    }
  } catch (error) {
    console.log(error);
  }
};

export const getFilterComments = (offerId, commentType) => async (dispatch) => {
  try {
    const url = `/${offerId}/comments?commentType=${commentType}`;
    const { responseBody } = await axios.get(url);
    return {
      filterComments: responseBody.data,
    };
  } catch (error) {
    console.log(error);
  }
};

export const setFileUploadIds = (fileId) => {
  return {
    type: constants.clientActions.uploadFile,
    fileId,
  };
};

export const getInnerComments = (offerId, progressId) => async (dispatch) => {
  try {
    const url = `/${offerId}/comments?progressId=${progressId}`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      return data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateComment =
  (
    offerId,
    progressId,
    comment,
    clarificationStatus,
    percentageCompletion,
    fileIds
  ) =>
  async (dispatch) => {
    try {
      const data = {
        progressId,
        comment,
        clarificationStatus,
        percentageCompletion,
        fileIds,
      };
      const url = `/job/progress`;
      const { responseStatus } = await axios.put(url, data);
      if (responseStatus === constants.status.success) {
        await dispatch(getOfferComments(offerId));
      }
    } catch (error) {
      console.log(error);
    }
  };
